
import { requests } from '.'
import { Filter } from '../commons/Types';
import HomeVideo from '../models/HomeVideo.model';
import ListData from '../models/List.model';

export const HomeVideoApi = {
  list: () => requests.get<ListData<HomeVideo>>('v1/home-video'), 
};